import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultCustomerOrderTemplate } from '@/utils/customerOrderDefaultTemplate';

export interface CustomerOrderFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; customerOrderJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const CustomerOrderFormDialog: React.FC<CustomerOrderFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; customerOrderJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      customerOrderJson: data.customerOrderJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New CustomerOrder"
      jsonFieldName="customerOrderJson"
      defaultJsonTemplate={defaultCustomerOrderTemplate()}
      jsonLabel="Enter a valid CustomerOrder JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the CustomerOrder schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
